module.exports = __webpack_public_path__ + "static/media/hotel.ef81a50d.jpg";